<template>
  <div class="float-right boss-batch-select">
    <select
      v-model="selectedTargetOption"
      class="boss-input-select"
    >
      <option
        v-for="(targetOption ,i) in targetOptions"
        :key="i"
        :data-test="'target-option-' + targetOption.key"
        :value="targetOption"
      >
        {{ targetOption.optionLabel }}
      </option>
    </select>
    <span v-tooltip="{content: showTooltip ? '一括操作は1回あたり2,000件以内です。':''}">
      <button
        :disabled="isDisabled"
        class="boss-button boss-exe-button pega-button"
        data-test="action-button"
        @click="doAction()"
      >
        <span class="boss-exe-button-text">
          実行する
        </span>
      </button>
    </span>
    <!-- ▼一括更新モーダル -->
    <div
      id="bulk-update-modal"
      class="reveal boss-modal-container pega-modal-position"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title pega-mb-25"
        data-test="modal-title"
      >
        {{ selectedTargetOption.name }}の一括更新
      </h1>
      <div class="boss-layout boss-layout-center">
        <div class="pega-bulk-update-container">
          <div>
            <div data-test="modal-body">
              選択したすべての応募者の{{ selectedTargetOption.name }}を
            </div>
            <select
              v-if="selectedTargetOption.key === 'status'"
              v-model="statusId"
              data-test="input-select-status"
              class="boss-input-select"
            >
              <option
                v-for="(status ,i) in statuses"
                :key="i"
                :data-test="'item-option-status-' + status.id"
                :value="status.id"
              >
                {{ status.name }}
              </option>
            </select>
            <textarea
              v-if="selectedTargetOption.key === 'remarks'"
              v-model="remarks"
              data-test="input-textarea-remarks"
              class="boss-send-textarea pega-textarea-resize-none"
            />
            <span>に</span>
          </div>
          <div>
            <button
              class="float-center boss-button-center boss-button-large pega-button pega-mr-20"
              type="button"
              data-test="update-button"
              @click="update()"
            >
              更新する
            </button>
            <button
              class="float-center boss-button-center boss-button-large"
              type="button"
              data-test="cancel-button"
              @click="closeReveal()"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        @click="closeReveal()"
      />
    </div>
    <!-- ▲一括更新モーダル -->
  </div>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { downloadCSV } from '@/lib/download'
import Indicator from '@/lib/indicator'
import cartInAnimation from '@/lib/cartInAnimation'

export default {
  components: {},
  props: {
    entryIds: {
      type: Array,
      required: true
    },
    selectLimit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selectedTargetOption: _.head(definition.seminarEntryBulkUpdate),
      remarks: '',
      statusId: null
    }
  },
  computed: {
    ...mapGetters([
      'seminarStatuses'
    ]),
    targetOptions: () => definition.seminarEntryBulkUpdate,
    statuses () {
      return [{ id: null, name: '-' }, ...this.seminarStatuses]
    },
    parameter () {
      if (this.selectedTargetOption.key === 'status') {
        return {
          entryIds: this.entryIds,
          statusId: this.statusId
        }
      } else {
        return {
          entryIds: this.entryIds,
          remarks: this.remarks
        }
      }
    },
    toastMessage () {
      return `${this.selectedTargetOption.name}を更新しました`
    },
    isDisabled () {
      return _.isEmpty(this.entryIds) || this.entryIds.length > this.selectLimit
    },
    showTooltip () {
      return this.entryIds.length > this.selectLimit
    }
  },
  methods: {
    doAction () {
      if (this.selectedTargetOption.key === 'create_bulk_message') {
        this.$router.push({
          name: 'seminarEntryBulkMessage',
          params: { entryIds: this.entryIds }
        })
      } else if (this.selectedTargetOption.key === 'csv_download') {
        downloadCSV(this.entryIds, true)
      } else {
        if (!this.modal) {
          this.modal = new Foundation.Reveal(jQuery('#bulk-update-modal'), { closeOnClick: false })
        }
        this.initializeModalData()
        this.modal.open()
      }
    },
    closeReveal () {
      this.modal.close()
    },
    initializeModalData () {
      this.$set(this, 'statusId', null)
      this.$set(this, 'remarks', '')
    },
    update () {
      Indicator.emitShow()
      this.$http.secured.put(`/seminar/entries/${this.selectedTargetOption.key}`, this.parameter).then(() => {
        this.$toasted.global.successRightTopSingleton({ message: this.toastMessage })
        this.statusId && this.startCartInAnimation(this.statusId)
        this.$emit('updated')
      }).finally(() => {
        Indicator.emitHide()
        this.closeReveal()
      })
    },
    startCartInAnimation (statusId) {
      // セミナーステータスを終了に変更した場合、文字列「#display-target-5」をtargetElementIdに代入
      const targetElementId = statusId === 5 ? `#display-target-${statusId}` : ''
      // #entry-entriesの要素はentryTopのentry-entriesコンポーネントをラップしているdivタグに付与されている
      targetElementId && cartInAnimation.start('#entry-entries', targetElementId)
    }
  }
}
</script>
